import { render } from "./xml.vue?vue&type=template&id=a99ef156&scoped=true"
import script from "./xml.vue?vue&type=script&lang=js"
export * from "./xml.vue?vue&type=script&lang=js"

import "./xml.vue?vue&type=style&index=0&id=a99ef156&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a99ef156"]])

export default __exports__